// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helper-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    background-color: #013020; /* Change this to white */
}
.helper-title {
    text-align: left;
    color: #f2cd01;
    font-size: 1.2rem;
    font-weight: bold;
  }

.chat-container {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #e0e0e0; /* Replace shadow with a subtle border */
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.message {
    margin-bottom: 15px;
    max-width: 70%;
    animation: fadeIn 0.3s ease-in-out;
    align-self: flex-start;
    background-color: transparent; 
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.message.user {
    align-self: flex-end;
}

.message-content {
    padding: 10px 15px;
    border-radius: 18px;
    display: inline-block;
    max-width: 100%;
    word-wrap: break-word;
}

.user .message-content {
    background-color: #007aff;
    color: white;
    border-bottom-right-radius: 4px;
}

.assistant .message-content {
    background-color: #e5e5ea;
    color: #000;
    border-bottom-left-radius: 4px;
}

.input-form {
    display: flex;
    background-color: #fff;
    border-radius: 20px;
    padding: 5px;
    border: 1px solid #e0e0e0; /* Replace shadow with a subtle border */
}

input[type="text"] {
    flex-grow: 1;
    padding: 10px 15px;
    font-size: 16px;
    border: none;
    background: transparent;
    outline: none;
}

button {
    padding: 10px;
    font-size: 16px;
    color: #007aff;
    background-color: transparent;
    border: none;
    cursor: pointer;
    transition: opacity 0.3s;
}

button:hover {
    opacity: 0.7;
}

button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.typing-indicator {
    display: flex;
    justify-content: center;
    align-items: center;
}

.typing-indicator span {
    height: 8px;
    width: 8px;
    background-color: #93989c;
    border-radius: 50%;
    display: inline-block;
    margin: 0 2px;
    opacity: 0.4;
    animation: typing 1s infinite;
}

.typing-indicator span:nth-child(2) {
    animation-delay: 0.2s;
}

.typing-indicator span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes typing {
    0% { transform: translateY(0px); }
    28% { transform: translateY(-5px); }
    44% { transform: translateY(0px); }
}`, "",{"version":3,"sources":["webpack://./src/Helper.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gGAAgG;IAChG,yBAAyB,EAAE,yBAAyB;AACxD;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;;AAEF;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB,EAAE,wCAAwC;IACnE,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,kCAAkC;IAClC,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB,EAAE,wCAAwC;AACvE;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;IACd,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,KAAK,0BAA0B,EAAE;IACjC,MAAM,2BAA2B,EAAE;IACnC,MAAM,0BAA0B,EAAE;AACtC","sourcesContent":[".helper-container {\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    box-sizing: border-box;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n    background-color: #013020; /* Change this to white */\n}\n.helper-title {\n    text-align: left;\n    color: #f2cd01;\n    font-size: 1.2rem;\n    font-weight: bold;\n  }\n\n.chat-container {\n    flex-grow: 1;\n    overflow-y: auto;\n    padding: 20px;\n    background-color: #fff;\n    border-radius: 8px;\n    border: 1px solid #e0e0e0; /* Replace shadow with a subtle border */\n    margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n}\n\n.message {\n    margin-bottom: 15px;\n    max-width: 70%;\n    animation: fadeIn 0.3s ease-in-out;\n    align-self: flex-start;\n    background-color: transparent; \n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.message.user {\n    align-self: flex-end;\n}\n\n.message-content {\n    padding: 10px 15px;\n    border-radius: 18px;\n    display: inline-block;\n    max-width: 100%;\n    word-wrap: break-word;\n}\n\n.user .message-content {\n    background-color: #007aff;\n    color: white;\n    border-bottom-right-radius: 4px;\n}\n\n.assistant .message-content {\n    background-color: #e5e5ea;\n    color: #000;\n    border-bottom-left-radius: 4px;\n}\n\n.input-form {\n    display: flex;\n    background-color: #fff;\n    border-radius: 20px;\n    padding: 5px;\n    border: 1px solid #e0e0e0; /* Replace shadow with a subtle border */\n}\n\ninput[type=\"text\"] {\n    flex-grow: 1;\n    padding: 10px 15px;\n    font-size: 16px;\n    border: none;\n    background: transparent;\n    outline: none;\n}\n\nbutton {\n    padding: 10px;\n    font-size: 16px;\n    color: #007aff;\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n    transition: opacity 0.3s;\n}\n\nbutton:hover {\n    opacity: 0.7;\n}\n\nbutton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.typing-indicator {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.typing-indicator span {\n    height: 8px;\n    width: 8px;\n    background-color: #93989c;\n    border-radius: 50%;\n    display: inline-block;\n    margin: 0 2px;\n    opacity: 0.4;\n    animation: typing 1s infinite;\n}\n\n.typing-indicator span:nth-child(2) {\n    animation-delay: 0.2s;\n}\n\n.typing-indicator span:nth-child(3) {\n    animation-delay: 0.4s;\n}\n\n@keyframes typing {\n    0% { transform: translateY(0px); }\n    28% { transform: translateY(-5px); }\n    44% { transform: translateY(0px); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
